import { CertificationTier } from '../ocpp';

export enum ChargingBoxModelCapabilities_201j {
  None = 0,
  OCPP201J_CORE = 1 << 0,
  OCPP201J_ADVANCED_SECURITY = 1 << 1,
  OCPP201J_LOCAL_AUTHORIZATION_LIST_MANAGEMENT = 1 << 2,
  OCPP201J_SMART_CHARGING = 1 << 3,
  OCPP201J_ADVANCED_DEVICE_MANAGEMENT = 1 << 4,
  OCPP201J_RESERVATION = 1 << 5,
  OCPP201J_ADVANCED_UI = 1 << 6,
  OCPP201J_CERTIFICATE_MANAGEMENT = 1 << 6,
  OCPP201J_ISO_15118_SUPPORT = 1 << 7,
  OCPP201J_V2G_SUPPORT = 1 << 8,

  OCPP201J_FULL_SUPPORT = OCPP201J_CORE |
    OCPP201J_ADVANCED_SECURITY |
    OCPP201J_LOCAL_AUTHORIZATION_LIST_MANAGEMENT |
    OCPP201J_SMART_CHARGING |
    OCPP201J_ADVANCED_DEVICE_MANAGEMENT |
    OCPP201J_RESERVATION |
    OCPP201J_RESERVATION |
    OCPP201J_ADVANCED_UI |
    OCPP201J_ISO_15118_SUPPORT |
    OCPP201J_V2G_SUPPORT,

  CAN_CHANGE_AUTHENTICATION = 1 << 9,
  SUPPORTS_UNLOCK_CONNECTOR = 1 << 10,
  SUPPORTS_PERMANENT_LOCKING = 1 << 11,
  CAN_WE_USE_METER_STOP = 1 << 12,
  NEED_TO_PLUG_BEFORE_START = 1 << 13,
  CAN_ADD_RFID = 1 << 14,
  CAN_DISPLAY_QR_CODE_WITH_LINK = 1 << 15,
  SUPPORTS_COST_UPDATED_STOP_TRANSACTION = 1 << 16, // after a stop transaction
  CAN_DISPLAY_TEXT = 1 << 17,
  CAN_DISPLAY_LINK = 1 << 18,
  DATA_TRANSFER_QR_CODE = 1 << 19, // does the charger model support displaying a qr code link using datatransfer
  DATA_TRANSFER_PRICE = 1 << 20, // does the charger model support displaying the price using datatransfer
  DATA_TRANSFER_LOGO = 1 << 21 // does the charger model support displaying the logo using datatransfer
}

export type ChargingBoxModelCapabilities_21j = ChargingBoxModelCapabilities_201j;

export enum RFIDScanType {
  Default = 0,
  MirroredPairByPair = 1
}

export enum BoolFormatEnum {
  StartLowerCase = 0,
  StartUpperCase = 1,
  UpperCaseSingleChar = 2,
  Numeric = 3
}

export type BoolFormat = keyof typeof BoolFormatEnum;

export enum ScreenCapabilities {
  None = 0,
  Screen = 1 << 1,
  DarkBackground = 1 << 2
}

export interface ChargingBoxModel {
  Amp?: number;
  canAddMoreSlaves: boolean;
  CanAddRFID: boolean;
  canBeSlave: boolean;
  CanWeUseMeterStop: boolean;
  CanWeUseMeterStopMeterValues: boolean;
  CertificationTier: CertificationTier;
  ChargingBoxModelCapabilities_16j: number;
  ChargingBoxModelCapabilities_201j: ChargingBoxModelCapabilities_201j;
  ChargingBoxModelCapabilities_21j: ChargingBoxModelCapabilities_21j;
  Description: string;
  DeviceIDMaxLength: number;
  documentation_link: string;
  DocumentsFolder: string;
  FK_ChargingManufacturerID: number;
  FK_ConnectorTypeID: number;
  FK_ConnectorTypeID2: number;
  HasConfig: boolean;
  HasKey: boolean;
  hasRFIDreader?: boolean;
  InstallationGuide: string;
  isOcpp12_soap: boolean;
  isOcpp15_soap: boolean;
  isOcpp16?: boolean;
  isOcpp16_soap: boolean;
  isOcpp20?: boolean;
  isOcpp21?: boolean;
  isSlaveOnly: boolean;
  j16_boolFormat: BoolFormat;
  j16_canChangeAuthentication?: boolean;
  j16_canPermanentlyLockCable?: boolean;
  j16_defaultBehaviorApproved?: boolean;
  j16_supportsAnyRfidWhenOffline: boolean;
  j16_supportsChargingProfile: boolean;
  j16_supportsFirmwareManagement?: boolean;
  j16_supportsSecurityProfiles: boolean;
  j16_supportsTriggerMessages: boolean;
  j16_supportsUnlockConnector?: boolean;
  LastVersionAvailable: string;
  LatestApprovedFirmwareVersion_16j: string;
  LatestApprovedFirmwareVersion_201j: string;
  ManufacturerName: string;
  max_heartbeat_interval: number;
  metervalues_sent_several_messages: boolean;
  Minimum_Value_Before_Pause: number;
  MinMeterValuesInterval?: number;
  ModelYear: string;
  Name: string;
  needToPlugBeforeStart?: boolean;
  NumberOfPoints: number;
  NumberOfSlaves: number;
  path_image_charger: string;
  Phase?: number;
  PK_ChargingBoxModelID: number;
  productNumber: string;
  regex_firmware_version: string;
  rfid_scan_type: RFIDScanType;
  screen_capabilities: ScreenCapabilities;
  Value_to_Pause: number;
  VendorName: string;
  Volts?: number;
  WebURL: string;
}
